import { render } from "./TicketShowDesk.vue?vue&type=template&id=1f6cb504"
import script from "./TicketShowDesk.vue?vue&type=script&lang=js"
export * from "./TicketShowDesk.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__